import { jsx as _jsx } from "react/jsx-runtime";
var ArrowLeft = function ArrowLeft(_ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    _ref$color = _ref.color,
    color = _ref$color === void 0 ? '#181B32' : _ref$color,
    ignoreColor = _ref.ignoreColor;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M16.6931 3.27917C16.295 2.89637 15.662 2.90879 15.2792 3.30689L6.5855 12.3483L15.3075 20.7214C15.7059 21.1039 16.3389 21.0909 16.7214 20.6925C17.1039 20.2941 17.0909 19.6611 16.6925 19.2786L9.41449 12.2917L16.7208 4.69311C17.1036 4.295 17.0912 3.66196 16.6931 3.27917Z",
      fill: !ignoreColor ? color : undefined
    })
  });
};
export default ArrowLeft;